import store from '@/store';
import {getTenantID} from '@/utils/util';

// URL of a pre-generated voice-preview MP3 served by speach-weet-player through the existing media CDN.
// `locale` may be null when the user picked "Auto-detect" in the language dropdown. in that case we
// fall back to the voice's home locale so a preview still plays.
export const getVoicePreviewURL = (provider: string, locale: string | null, voiceId: string): string => {
    if (!provider || !voiceId) {
        return '';
    }
    const effectiveLocale = locale || defaultLocaleForVoice(voiceId);
    return `${store.getters.getCdnVideo}/${getTenantID()}/media/PreviewVoices/${provider}/${effectiveLocale}/${voiceId}.mp3`;
};

// Microsoft voice ids are "xx-XX-Name". The home locale is the first two segments. Gemini ids
// (Aoede, Kore, etc.) carry no locale. en-US is the most universally pre-generated default.
const defaultLocaleForVoice = (voiceId: string): string => {
    const match = voiceId.match(/^([a-z]{2,3}-[A-Z]{2})-/);
    return match ? match[1] : 'en-US';
};
